import { createAction, props } from '@ngrx/store';
export const GET_QUOTE = '[Quote] Get Quote';
export const GET_QUOTE_SUCCESS = '[Quote] Get Quote Success';
export const GET_QUOTE_FAILURE = '[Quote] Get Quote Failures';

export const REJECT_QUOTE = '[Quote] Reject Quote';
export const REJECT_QUOTE_SUCCESS = '[Quote] Reject Quote Success';
export const REJECT_QUOTE_FAILURE = '[Quote] Reject Quote Failures';

export const REJECT_TRIP = '[Quote] Reject Trip';
export const REJECT_TRIP_SUCCESS = '[Quote] Reject Trip Success';
export const REJECT_TRIP_FAILURE = '[Quote] Reject Trip Failures';

export const ACCEPT_QUOTE = '[Quote] Accept Quote';
export const ACCEPT_QUOTE_SUCCESS = '[Quote] Accept Quote Success';
export const ACCEPT_QUOTE_FAILURE = '[Quote] Accept Quote Failures';

export const COMPARE_QUOTE = '[Quote] Compare Quote';
export const COMPARE_QUOTE_SUCCESS = '[Quote] Compare Quote Success';
export const COMPARE_QUOTE_FAILURE = '[Quote] Compare Quote Failures';

export const REQUEST_CALLBACK = '[Quote] Request Callback';
export const REQUEST_CALLBACK_SUCCESS = '[Quote] Request Callback Success';
export const REQUEST_CALLBACK_FAILURE = '[Quote] Request Callback Failures';

export const COMPARE_QUOTES = '[Compare Quotes] Compare Quotes';
export const COMPARE_QUOTES_SUCCESS = '[Compare Quotes] Compare Quotes Success';
export const COMPARE_QUOTES_FAILURE = '[Compare Quotes] Compare Quotes Failure';

export const LEAD_COMPARE_QUOTES = '[Compare Quotes] Lead Compare Quotes';
export const LEAD_COMPARE_QUOTES_SUCCESS =
  '[Compare Quotes] Lead Compare Quotes Success';
export const LEAD_COMPARE_QUOTES_FAILURE =
  '[Compare Quotes] Lead Compare Quotes Failure';

export const CLEAR_STATE = '[Quote] clear state';

export const getQuote = createAction(GET_QUOTE, props<{ queryParams?: any }>());
export const getQuoteSuccess = createAction(
  GET_QUOTE_SUCCESS,
  props<{ data: any }>()
);
export const getQuoteFailure = createAction(
  GET_QUOTE_FAILURE,
  props<{ data: any }>()
);

export const rejectQuote = createAction(REJECT_QUOTE, props<{ data?: any }>());
export const rejectQuoteSuccess = createAction(
  REJECT_QUOTE_SUCCESS,
  props<{ data: any }>()
);
export const rejectQuoteFailure = createAction(
  REJECT_QUOTE_FAILURE,
  props<{ data: any }>()
);

export const rejectTrip = createAction(
  REJECT_TRIP,
  props<{ data?: any; leadId: any }>()
);
export const rejectTripSuccess = createAction(
  REJECT_TRIP_SUCCESS,
  props<{ data: any }>()
);
export const rejectTripFailure = createAction(
  REJECT_TRIP_FAILURE,
  props<{ data: any }>()
);

export const requestCallback = createAction(
  REQUEST_CALLBACK,
  props<{ data?: any }>()
);
export const requestCallbackSuccess = createAction(
  REQUEST_CALLBACK_SUCCESS,
  props<{ data: any }>()
);
export const requestCallbackFailure = createAction(
  REQUEST_CALLBACK_FAILURE,
  props<{ data: any }>()
);

export const acceptQuote = createAction(
  ACCEPT_QUOTE,
  props<{ _id: any; data?: any }>()
);
export const acceptQuoteSuccess = createAction(
  ACCEPT_QUOTE_SUCCESS,
  props<{ data: any }>()
);
export const acceptQuoteFailure = createAction(
  ACCEPT_QUOTE_FAILURE,
  props<{ data: any }>()
);

export const clearState = createAction(CLEAR_STATE);

export const compareQuotes = createAction(
  COMPARE_QUOTES,
  props<{ data: any }>()
);

export const compareQuotesSuccess = createAction(
  COMPARE_QUOTES_SUCCESS,
  props<{ data: any }>()
);

export const compareQuotesFailure = createAction(
  COMPARE_QUOTES_FAILURE,
  props<{ error: any }>()
);

export const leadCompareQuotes = createAction(
  LEAD_COMPARE_QUOTES,
  props<{ leadId: string }>()
);

export const leadCompareQuotesSuccess = createAction(
  LEAD_COMPARE_QUOTES_SUCCESS,
  props<{ data: any }>()
);

export const leadCompareQuotesFailure = createAction(
  LEAD_COMPARE_QUOTES_FAILURE,
  props<{ error: any }>()
);
